export default {
  title: 'Relación de facturas de terceros (Gastos suplidos)',
  rejectedBill: 'Factura rechazada',
  caixaRestriction: 'Bankia/CaixaBank no permite la asociación de suplidos para esta factura'
}
